const parseMainStatus = status => {
  if (!status) {
    return { type: 'error', message: 'No health checks were found' };
  }
  if (status?.log?.status === 'OK') {
    return { type: 'success', message: 'All Systems Operational' };
  } else {
    return { type: 'error', message: 'Something is down' };
  }
};

export default parseMainStatus;
